import { CSSProperties, FC, useMemo } from 'react';

import { useTheme } from '@mui/material';

import logo from 'assets/images/logo.svg';
import logoDark from 'assets/images/logo-dark.svg';
import minimalLogo from 'assets/images/minimal-logo.svg';

interface LogoProps {
    isMinimalLogo?: boolean;
    sx?: CSSProperties;
}

const Logo: FC<LogoProps> = (props) => {
    const { isMinimalLogo, sx } = props;
    const theme = useTheme();

    const themeLogo = useMemo(() => (theme.palette.mode === 'dark' ? logoDark : logo), [theme.palette.mode]);

    if (isMinimalLogo) return <img src={minimalLogo} alt="Documentale Logo" width="45" style={sx} />;

    return <img src={themeLogo} alt="Documentale Logo" width="100" style={sx} />;
};
export default Logo;
